/*
 * @Author: Teemo Ding
 * @Date: 2021-04-21 16:38:44
 * @LastEditTime: 2021-08-05 16:17:13
 * @LastEditors: Teemo Ding
 * @Description: product content request
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/product/content.ts
 */
import { post, get, remove } from 'src/tools/server';

export const request_ProductContent = (
  salesChannelProductUuid: string,
  params,
) => {
  return get<any>(
    `/portal/salesChannelProductContent/initialize/${salesChannelProductUuid}`,
    params || {},
  );
};

export const request_SaveProductContent = (salesChannelProduct, params) => {
  return post<any>(
    `/portal/salesChannelProductContent`,
    salesChannelProduct,
    params || {},
  );
};

export const request_SaveAliasProductContent = (
  salesChannelProduct,
  params,
) => {
  return post<any>(
    `/portal/salesChannelProductContent/alias/add/${salesChannelProduct.contentUuid}`,
    salesChannelProduct,
    params || {},
  );
};
export const request_DuplicateAliasProductContent = (salesChannelProduct) => {
  return post<any>(
    `/portal/salesChannelProductContent/alias/add/${salesChannelProduct.uuid}?duplicate=true`,
    salesChannelProduct,
    {},
  );
};

export const request_AliasDetail = (aliasUuid, params) => {
  return get<any>(
    `/portal/salesChannelProductContent/alias/${aliasUuid}`,
    params || {},
  );
};

export const request_DeleteAlias = (salesChannelProductContentAliasUuid) => {
  return remove<any>(
    `/portal/salesChannelProductContent/alias/${salesChannelProductContentAliasUuid}`,
    {},
  );
};
